export default __webpack_public_path__ + "static/media/whatsAppRealcase-mobile.b6acaf05.png";